import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'itl-button-borderless',
  template: '<ng-content></ng-content>',
  styleUrls: ['./button-borderless.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ButtonBorderlessComponent implements OnChanges {
  // Set to "block" for a full-width with left and right borders.
  @Input() expand: 'block' | undefined;
  @Input() disabled = false;

  @HostBinding('class.displayBlock') displayBlock = false;
  @HostBinding('class.disabled') disabledStyle = false;

  ngOnChanges(changes: SimpleChanges): void {
    this.displayBlock = this.expand === 'block';
    this.disabledStyle = this.disabled;
  }
}
